import { Outlet } from 'react-router'

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950 p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-bold text-xl bg-primary-500">
            F
          </div>
          <span className="ml-3 text-2xl font-bold text-zinc-900 dark:text-zinc-100">
            Floaty
          </span>
        </div>
        <Outlet />
      </div>
    </div>
  )
}
